import { IRootState } from '../../../store'
import { ITimesState } from '../store/times.types'

export const getTimesSelector = (state: IRootState): ITimesState => state.times
